import React from 'react';
import Styled from './DropdownControl.style';
import { DropdownControlProps } from '../../interfaces';
import { useTranslation } from 'react-i18next';
const DropdownControl: React.FC<DropdownControlProps> = (props) => {
  const {
    answerKey,
    value,
    defaultValue,
    options,
    disabled,
    updateAnswerKey = () => void 0,
  } = props;

  const currentValue = value !== undefined ? value : (defaultValue ?? '');

  const selectValue = currentValue === null ? '__NO_LEAK__' : currentValue;
  const [t] = useTranslation('common');
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value === '__NO_LEAK__' ? null : e.target.value;
    updateAnswerKey(answerKey, value);
  };

  return (
    <Styled.Wrapper>
      <Styled.Select
        value={selectValue}
        onChange={handleChange}
        disabled={disabled}
      >
        {options.map((option) => (
          <option
            key={option.value ?? '__NO_LEAK__'}
            value={option.value ?? '__NO_LEAK__'}
            disabled={option.value === ''}
            hidden={option.value === ''}
          >
            {t(option.label)}
          </option>
        ))}
      </Styled.Select>
    </Styled.Wrapper>
  );
};

export default DropdownControl;
